import styled from '@emotion/styled'
import { Box } from '@mui/material'
import React, { RefObject, useState } from 'react'
import ReactPlayer from 'react-player'
import BaseReactPlayer, { BaseReactPlayerProps } from 'react-player/base'

import { ArtistPostVideoFragment } from '@/clients/utoniq-core/schema'
import { individualDisplayResponsive } from '@/core/individual'

import { ShortVideoControl } from './ShortVideoControl'

const StyledReactPlayer = styled.div`
  video {
    object-fit: cover;
  }
`
export const ShortVideoPlayer = ({
  post,
  videoRef,
  playing,
  muted,
  action,
  maxWidth = '600px',
}: {
  post: ArtistPostVideoFragment
  videoRef: RefObject<BaseReactPlayer<BaseReactPlayerProps>>
  playing: boolean
  muted: boolean
  maxWidth?: string
  action: {
    play: () => void
    pause: () => void
    togglePlay: () => void
    seek: (time: number) => void
    defaultMute: () => void
    onLike: () => void
    onReportArtist?: () => Promise<void>
    onBlockArtist?: () => Promise<void>
    onClose: () => void
  }
}) => {
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)

  const displayResponsive = individualDisplayResponsive()

  return (
    <StyledReactPlayer>
      <Box onClick={action.togglePlay}>
        <ReactPlayer
          style={{
            maxWidth: maxWidth,
          }}
          {...(displayResponsive
            ? { width: '100vw', height: 'auto' }
            : { width: '100%', height: '100dvh' })}
          url={post.resource?.uri ?? ''}
          ref={videoRef}
          playing={playing}
          progressInterval={100}
          onProgress={p => setCurrentTime(p.playedSeconds)}
          onSeek={setCurrentTime}
          onDuration={setDuration}
          onError={e => {
            // NOTE
            // 上位コンポーネントでデフォルトでmuted=false（ミュートさせない）に設定している。
            // モバイル環境では、muted=trueでないとautoplayに失敗し、errorイベントが発生する。
            // そのうえでautoplayを成功させるため、エラー発生時にのみmuted=trueに設定し直すことでautoplayを成功させる。
            if (e !== null) {
              action.defaultMute()
            }
          }}
          playsinline
          loop
          muted={muted}
          config={{
            file: {
              attributes: {
                poster: post.videoThumbnail?.uri || '',
                preload: 'metadata',
              },
            },
          }}
        />
      </Box>
      <ShortVideoControl
        post={post}
        state={{ currentTime, duration, isPlaying: playing }}
        action={action}
      />
    </StyledReactPlayer>
  )
}
